import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LeftSideAnimation from "../animations/LeftAndRightSideAnimation";
import FadeInAnimation from "../animations/FadeInAnimation";
import {
  useFetchForumQuery,
  useFetchForumSportsQuery,
  useFetchAllSportsQuery,
} from "../../store/api/apiSlice";
import Loader from "../../ui/Loader";
import { Button } from "react-bootstrap";
import { HashLoader } from "react-spinners";
const ListCard = ({ userId, selectedSchool, selectedSport }) => {
  const { data: sportsData } = useFetchAllSportsQuery();

  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const sportsID = params.get("sportsID");

  const { data: forumData, isLoading, error, refetch } = useFetchForumQuery();
  const { data: forumSportsData } = useFetchForumSportsQuery(sportsID, {
    skip: !sportsID,
  });
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const dataToDisplay = sportsID ? forumSportsData : forumData;

  const forumsToDisplay =
    dataToDisplay?.forums?.filter((forum) => {
      const matchesUserId = userId ? forum.creatorId === userId : true;
      const matchesSchool = selectedSchool
        ? forum.schoolName === selectedSchool
        : true;
      const matchesSport = selectedSport
        ? forum.sportsName === selectedSport
        : true;
      return matchesUserId && matchesSchool && matchesSport;
    }) || [];

  const [showMore, setShowMore] = useState(false);

  const handleToggleDetails = () => {
    setShowMore((prevShowMore) => !prevShowMore);
  };
  const paginatedUsers = forumsToDisplay.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(forumsToDisplay.length / itemsPerPage);
  const formatDate = (createdAt) => {
    const now = new Date();
    const createdDate = new Date(createdAt);
    const timeDiff = now - createdDate;

    const seconds = Math.floor(timeDiff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days < 7) {
      if (days > 0) {
        return `${days} day${days > 1 ? "s" : ""} ago`;
      } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? "s" : ""} ago`;
      } else if (minutes > 0) {
        return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
      } else {
        return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
      }
    } else {
      return createdDate.toLocaleDateString();
    }
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <HashLoader color="#00b386" size={70} />
      </div>
    );
  }
  return (
    <>
      {paginatedUsers.length > 0 ? (
        paginatedUsers.map((item, index) => {
          const sport = sportsData?.sports.find(
            (sport) => sport.name === item.sportsName
          );
          return (
            <div
              className="card"
              key={index}
              onClick={() => navigate(`/forumDetail/${item._id}`)}
            >
              <div className="card-body">
                <h4 className="eventname">{item?.title}</h4>

                <div className="mob-flex">
                  <h4 className="concoursetitle3">
                    {sport ? (
                      <img
                        src={`${baseUrl}/${sport.sportsFile}`}
                        alt={item?.sportsName}
                        className="ballicon1"
                      />
                    ) : null}
                    <span>{item?.sportsName}</span>
                  </h4>

                  <h4 className="concoursetitle3">
                    <img
                      src="/images/vninter.png"
                      alt="Profile"
                      className="ballicon1"
                    />
                    <span className="text-black">{item?.schoolName}</span>
                  </h4>
                </div>

                <p
                  className="concoursepara"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: showMore ? "none" : 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    height: showMore ? "auto" : "",
                    lineHeight: "1.5em",

                    cursor: "pointer",
                  }}
                  onClick={handleToggleDetails}
                >
                  {item?.description}
                </p>
                {showMore && (
                  <div>
                    <p>{item?.additionalDetails}</p>
                  </div>
                )}

                <div className="mob-flex2 badgeshow ">
                  {item?.tags?.map((tags, tagsIndex) => {
                    return (
                      <span key={tagsIndex} className="badge badge-primary">
                        {tags}
                      </span>
                    );
                  })}
                </div>

                <div className="iconshowlistitem">
                  <div style={{ display: "flex" }}>
                    <h5 className="icontextlist">
                      <img src="/images/list-1.png" className="img-fluid" />
                      <span>{item?.viewCounter}</span>
                    </h5>
                    <h5 className="icontextlist">
                      <img src="/images/list-2.png" className="img-fluid" />

                      <span>{item?.members?.length || 0}</span>
                    </h5>

                    <h5 className="icontextlist">
                      <img src="/images/list-4.png" className="img-fluid" />
                      <span>{item?.messages}</span>
                    </h5>
                  </div>
                  <div>
                    <h5 className="icontextlist card_texth5">
                      <span className="card_textSpan"> Start Date:</span>

                      <span className="card_textDate">
                        {formatDate(item?.createdAt)}
                      </span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <h5 className="listCard_text_noForum">No Forum Found</h5>
      )}
      <div className="d-flex justify-content-center mt-3">
        {Array.from({ length: totalPages }, (_, index) => (
          <Button
            key={index}
            variant={currentPage === index + 1 ? "primary" : "outline-primary"}
            onClick={() => setCurrentPage(index + 1)}
            className="mx-1"
          >
            {index + 1}
          </Button>
        ))}
      </div>
    </>
  );
};

export default ListCard;
